/* ============
 * Debug Store
 * ============
 *
 * Keeps the `dbug` id it had as a Vuex module.
 */

import { defineStore } from 'pinia';
import './pinia';

export const useDebugStore = defineStore('dbug', {
  state: () => ({
    debug: false,
  }),

  actions: {
    open() {
      this.debug = !this.debug;
    },

    close() {
      this.debug = false;
    },
  },
});

export default useDebugStore;
